import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { salesOrderService } from '@kss/api';
import type { SalesOrderCreate } from '@kss/api';
import { loadStoreOptions, loadUserOptions } from '../shared/formLoaders';

const columns: BulkColumn<SalesOrderCreate>[] = [
  { key: 'orderNumber', header: 'Order #', required: true, sample: 'SO-1001' },
  { key: 'orderDate', header: 'Order date', dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'channel', header: 'Channel', sample: 'B2C' },
  { key: 'status', header: 'Status', sample: 'Draft' },
  { key: 'customerId', header: 'Customer', dataType: 'lookup', loadOptions: loadUserOptions },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'totalAmount', header: 'Total', dataType: 'number', parse: parseNum as never, required: true, sample: '1500' },
  { key: 'discountAmount', header: 'Discount', dataType: 'number', parse: parseNum as never },
  { key: 'taxAmount', header: 'Tax', dataType: 'number', parse: parseNum as never },
  { key: 'shippingAmount', header: 'Shipping', dataType: 'number', parse: parseNum as never },
  { key: 'notes', header: 'Notes' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkSalesOrder() {
  return (
    <BulkSpreadsheet<SalesOrderCreate> title="Bulk import sales orders" entityLabel="order" backPath="/panel/sales-orders" columns={columns} module="SalesOrder"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, totalAmount: Number(r.totalAmount ?? 0), isActive: r.isActive ?? true }));
        const created = await salesOrderService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
